var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSurprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 142,
    viewBox: "0 0 170 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5856 19.6043C39.5856 30.5374 30.9144 39.2086 19.9813 39.2086C8.67112 39.5856 0 30.5374 0 19.6043C0 8.67112 8.67112 0 19.6043 0C30.5374 0 39.5856 8.67112 39.5856 19.6043Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.949 19.6043C154.949 30.5374 146.278 39.2086 135.345 39.2086C124.411 39.2086 115.74 30.5374 115.74 19.6043C115.74 8.67112 124.034 0 134.968 0C145.901 0 154.949 8.67112 154.949 19.6043Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.126 112.724C42.2249 106.692 38.0778 98.0211 39.5858 90.1039C41.0939 83.3179 46.7489 79.9248 53.158 78.7938C64.0912 76.5318 77.2864 78.0398 88.5965 78.0398C101.038 78.0398 113.856 78.4168 126.297 79.9248C140.623 81.4328 174.931 85.9569 168.145 108.2C167.014 112.347 164.375 116.117 161.736 119.51C134.968 154.195 72.0083 143.262 47.126 112.724Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.168 140.247C104.053 121.02 119.134 106.316 137.607 106.316C147.786 106.316 156.457 110.84 163.243 118.004C162.866 118.381 162.866 118.758 162.489 119.135C148.163 137.231 124.789 142.886 102.168 140.247Z",
    fill: "#FF7192"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSurprise);
export default __webpack_public_path__ + "static/media/face_surprise.faa34f8dcdd50e7b8a2cfb95bafc3d69.svg";
export { ForwardRef as ReactComponent };